import React from 'react';
import { DisplayField } from '@digitools/honest-ui';
import useTranslate from 'src/hooks/useTranslate';
import useAsDataContext from '../../hooks/useAsDataContext';
import { getSelectedDropDownItemsAsString, getDocumentList } from '../../utils/AsDataUtils';
import useAsContext from '../../hooks/useAsConfigContext';
import { AS_YES_NO_OPTIONS } from '../../constants/Constants';
import { ReviewText } from '../../constants/ReviewText';
import { CustomEmployeeText } from 'src/utils/CustomExperienceText';
import { Experience } from 'src/types/Experience';
import useExperience from 'src/hooks/useExperience';
const ReviewConditionsCircumstance = ({ onEdit }) => {
    const { conditionData, documents } = useAsDataContext();
    const { asConfig } = useAsContext();
    const { t } = useTranslate();
    const { experience } = useExperience();
    const conditionText = conditionData?.conditions && getSelectedDropDownItemsAsString(asConfig?.config?.conditionDropDown, conditionData?.conditions, t);
    const workRelatedText = conditionData?.workRelated && getSelectedDropDownItemsAsString(AS_YES_NO_OPTIONS, conditionData?.workRelated, t);
    const uploadingDocuments = (documents && documents?.length > 0) ? getDocumentList(documents) : '';
    const rlLabel = CustomEmployeeText(experience === Experience.EMPLOYEE ? t(ReviewText.conditionCircumstance.formLabels.reportedRestrictonOrLimitationEE) : t(ReviewText.conditionCircumstance.formLabels.reportedRestrictonOrLimitationER));
    // DisplayField entries only take label/value, so data-private goes on a wrapper inside the value
    const fields = [
        ...(experience === Experience.EMPLOYER && asConfig?.config?.asRep
            ? [{ label: CustomEmployeeText(t(ReviewText.conditionCircumstance.formLabels.receivedDate)), value: conditionData?.receivedDate }]
            : []),
        { label: t(ReviewText.conditionCircumstance.formLabels.conditions), value: <span data-private={true}>{conditionText}</span> },
        { label: t(ReviewText.conditionCircumstance.formLabels.workRelated), value: workRelatedText },
        { label: rlLabel, value: <span data-private={true}>{conditionData?.conditionText}</span> },
        { label: t(ReviewText.conditionCircumstance.formLabels.availableDocumentation), value: uploadingDocuments },
    ];
    return (<div data-testid={'review-conditions-circumstance'}>
      <DisplayField title={t(ReviewText.conditionCircumstance.accommTitle)} headingLevel='h3' className='hui-mb-lg' columns={1} fields={fields} onEdit={onEdit} 
    // Passed explicitly: the app wraps honest-react's LanguageProvider, not honest-ui's, so the default would stay English
    editLabel={t(ReviewText.editButton)}/>
    </div>);
};
export default React.memo(ReviewConditionsCircumstance);
